import { css } from 'styled-components';

interface DashedBorderOptions {
  color?: string;
  strokeWidth?: number;
  dashArray?: string;
  dashOffset?: number;
  lineCap?: 'butt' | 'round' | 'square';
  borderRadius?: number;
  sides?: {
    top?: boolean;
    right?: boolean;
    bottom?: boolean;
    left?: boolean;
  };
}

export const dashedBorder = ({
  color = '#333333',
  strokeWidth = 2,
  dashArray = '6, 14',
  dashOffset = 0,
  lineCap = 'square',
  borderRadius = 0,
  sides,
}: DashedBorderOptions = {}): ReturnType<typeof css> => {
  const sideFlags = {
    top: sides?.top ?? true,
    right: sides?.right ?? true,
    bottom: sides?.bottom ?? true,
    left: sides?.left ?? true,
  };

  const hasAllSides =
    sideFlags.top && sideFlags.right && sideFlags.bottom && sideFlags.left;
  const safeRadius = Math.max(0, borderRadius);
  const radiusAttr =
    safeRadius > 0 ? ` rx="${safeRadius}" ry="${safeRadius}"` : '';

  const sideLines: string[] = [];

  if (sideFlags.top) sideLines.push(`<line x1="0" y1="0" x2="100%" y2="0" />`);
  if (sideFlags.right)
    sideLines.push(`<line x1="100%" y1="0" x2="100%" y2="100%" />`);
  if (sideFlags.bottom)
    sideLines.push(`<line x1="0" y1="100%" x2="100%" y2="100%" />`);
  if (sideFlags.left) sideLines.push(`<line x1="0" y1="0" x2="0" y2="100%" />`);

  const shape = hasAllSides
    ? `<rect width="100%" height="100%"${radiusAttr} fill="none" />`
    : sideLines.join('');

  const svgRaw = `<svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke="${color}" stroke-width="${strokeWidth}" stroke-dasharray="${dashArray}" stroke-dashoffset="${dashOffset}" stroke-linecap="${lineCap}">${shape}</g></svg>`;
  const svg = encodeURIComponent(svgRaw);

  return css`
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url('data:image/svg+xml,${svg}');
  `;
};
